module.exports = __webpack_public_path__ + "img/upper pocket height.b7651cfd.png";